export default __webpack_public_path__ + "dist/media/OpenArrow.1053a00d.svg";